module.exports = __webpack_public_path__ + "4807301f912f95ccc7a56d3afc3ecf7b.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-88.cur
// module id = 483
// module chunks = 0